export interface MenuAction {
	action: MenuActionType;
	value?: string | ChatInfo;
}

export enum MenuActionType {
	BACK = 'BACK',
	OPEN_CHAT = 'OPEN_CHAT',
	RESET_CHAT = 'RESET_CHAT',
	REFRESH_CHAT_LIST = 'REFRESH_CHAT_LIST',
	GO_HOME = 'GO_HOME',
	OPEN_TRAINING = 'OPEN_TRAINING',
	CREATE_ACTIVITY = 'CREATE_ACTIVITY',
	CREATE_TEST = 'CREATE_TEST',
	CREATE_SUMMARY = 'CREATE_SUMMARY',
	CREATE_TERM = 'CREATE_TERM',
	CREATE_FORMULA = 'CREATE_FORMULA',
	CREATE_CASE_STUDY = 'CREATE_CASE_STUDY',
	CREATE_FLASHCARD = 'CREATE_FLASHCARD',
	CREATE_TRUE_FALSE = 'CREATE_TRUE_FALSE',
	SET_CORRECTION = 'SET_CORRECTION'
}

export interface ChatInfo {
	chatId: number;
	topicId: number;
}
